<template>
    <el-dialog
        :title="'发车单打印'"
        :width="'800px'"
        :visible.sync="dialogVisible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceDispatchPrintDialog'"
        top="5vh"
    >
        <el-scrollbar style="height: 100%">
            <div class="performanceDispatchPrintWapper">
                <el-radio-group v-model="printRadio" @change="changeEvent">
                    <el-row :gutter="20">
                        <el-col
                            v-for="item in printList.filter((v) => v.expose)"
                            :key="item.value"
                            :span="8"
                            style="margin-bottom: 20px"
                            :draggable="isNeedDrag"
                            @dragstart.native="
                                (e) => proxyDrag(e, item, 'dragstart')
                            "
                            @dragend.native="
                                (e) => proxyDrag(e, item, 'dragend')
                            "
                            @dragenter.native="
                                (e) => proxyDrag(e, item, 'dragenter')
                            "
                            @dragover.native="
                                (e) => proxyDrag(e, item, 'dragover')
                            "
                            @dragleave.native="
                                (e) => proxyDrag(e, item, 'dragleave')
                            "
                            @drop.native="(e) => proxyDrag(e, item, 'drop')"
                        >
                            <el-radio
                                :label="item.value"
                                border
                                style="width: 100%"
                            >{{ item.label }}</el-radio>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-collapse v-model="activeName" accordion>
                            <el-collapse-item title="点击展开更多单据打印" name="1">
                                <el-col
                                    v-for="item in printList.filter(
                                        (v) => !v.expose && !v.collapseType
                                    )"
                                    :key="item.value"
                                    :span="8"
                                    style="margin-bottom: 20px"
                                    :draggable="isNeedDrag"
                                    @dragstart.native="
                                        (e) => proxyDrag(e, item, 'dragstart')
                                    "
                                    @dragend.native="
                                        (e) => proxyDrag(e, item, 'dragend')
                                    "
                                    @dragenter.native="
                                        (e) => proxyDrag(e, item, 'dragenter')
                                    "
                                    @dragover.native="
                                        (e) => proxyDrag(e, item, 'dragover')
                                    "
                                    @dragleave.native="
                                        (e) => proxyDrag(e, item, 'dragleave')
                                    "
                                    @drop.native="
                                        (e) => proxyDrag(e, item, 'drop')
                                    "
                                >
                                    <el-radio
                                        :label="item.value"
                                        border
                                        style="width: 100%"
                                    >{{ item.label }}</el-radio>
                                </el-col>
                            </el-collapse-item>
                        </el-collapse>
                    </el-row>
                    <el-row :gutter="20">
                        <el-collapse v-model="activeName" accordion>
                            <el-collapse-item title="点击展开基地单据打印" name="2">
                                <el-col
                                    v-for="item in printList.filter(
                                        (v) => v.collapseType === 'trunk'
                                    )"
                                    :key="item.value"
                                    :span="8"
                                    style="margin-bottom: 20px"
                                    :draggable="isNeedDrag"
                                    @dragstart.native="
                                        (e) => proxyDrag(e, item, 'dragstart')
                                    "
                                    @dragend.native="
                                        (e) => proxyDrag(e, item, 'dragend')
                                    "
                                    @dragenter.native="
                                        (e) => proxyDrag(e, item, 'dragenter')
                                    "
                                    @dragover.native="
                                        (e) => proxyDrag(e, item, 'dragover')
                                    "
                                    @dragleave.native="
                                        (e) => proxyDrag(e, item, 'dragleave')
                                    "
                                    @drop.native="
                                        (e) => proxyDrag(e, item, 'drop')
                                    "
                                >
                                    <el-radio
                                        :label="item.value"
                                        border
                                        style="width: 100%"
                                    >{{ item.label }}</el-radio>
                                </el-col>
                            </el-collapse-item>
                        </el-collapse>
                    </el-row>
                </el-radio-group>
            </div>
        </el-scrollbar>

        <!-- 内层dialog 蓝月亮打印列表 -->
        <bluemoon-print-dialog
            :bluemoonPrintVisible.sync="bluemoonPrintVisible"
            :data="bluemoonList"
            @closePrintDialog="beforeCloseAllDialog"
            v-if="bluemoonPrintVisible"
        ></bluemoon-print-dialog>

        <dispatch-print-log
            v-if="isShowPrintLogDialog"
            ref="dispatchPrintLog"
            :isShowPrintLogDialog.sync="isShowPrintLogDialog"
            :componentsData="componentsData"
        ></dispatch-print-log>

        <dispatch-repeat-print
            v-if="isShowPrintReasonDialog"
            ref="dispatchRepeatPrint"
            :isShowPrintReasonDialog.sync="isShowPrintReasonDialog"
            :componentsData="componentsData"
            :tooltip="tooltip"
            @handlePrint="handlePrint"
        ></dispatch-repeat-print>

        <template #footer>
            <div>
                <el-button @click="beforeClose">取消</el-button>
                <el-button type="primary" @click="openPrintLog">打印日志</el-button>
                <el-button type="primary" :loading="btnLoading" @click="handleSubmit">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import BluemoonPrintDialog from './BluemoonPrintDialog.vue';
import DispatchPrintLog from '../../dispatchMgmt/components/dispatchPrintLog/Index';
import DispatchRepeatPrint from '../../dispatchMgmt/components/dispatchRepeatPrint/Index.vue';
import { printList } from './config.js';
import { dealWithPrintLogic, isValidate } from './util.js';
import dragEventList from './drag.js';
import { checkPrintCount  } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: 'dispatchArrivalRegistration',
    components: {
        BluemoonPrintDialog,
        DispatchPrintLog,
        DispatchRepeatPrint
    },
    props: {
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        },
        dialogVisible: {
            type: Boolean,
            default: false
        },
        professionalCompanyConfig: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            btnLoading: false, // 确定按钮加载动画
            visible: false, // 发车单打印窗口
            bluemoonPrintVisible: false, // 蓝月亮打印窗口
            printRadio: '', // 当前打印的单据值
            printList: printList,
            bluemoonList: [], // 蓝月亮单据打印列表
            activeName: '0',
            isNeedDrag: false, // 是否需要拖拽
            isShowPrintLogDialog: false,
            isShowPrintReasonDialog: false,
            repeatPrintReason: {},
            tooltip: '',
            CPLimit: false,
            LDLimit: false
        };
    },
    methods: {
        // 代理拖拽
        proxyDrag (event, data, eventName) {
            if (this.isNeedDrag) {
                dragEventList.action(event, data, eventName, this);
                if (eventName === 'drop') { /** 提交最终排序结果 this.printList */ }
            }
        },
        /**
         * @description 选项变化时触发事件
         */
        changeEvent (printRadio) {
            // 配送单(新隆)：发车单状态小于30提示
            if (printRadio === 'tms_psd_xl' && this.componentsData.originDispatchStatus <= 10) {
                console.log(112345);
                return this.$message.warning('装车之前打印此配送单，包裹号及箱号为空，在WMS操作出库后包裹号及箱号会有值');
            }
            // 提货清单提示语
            if (printRadio === 'tms_pickup_list') {
                return this.$message.warning('装车之前打印此提货清单，包裹号及箱号为空，在WMS操作出库后包裹号及箱号会有值');
            }
            // 分货单 提示语
            if (printRadio === 'tms_fhd') {
                return this.$message.warning('装车之前打印此分货单，包裹号及箱号为空，在WMS操作出库后包裹号及箱号会有值');
            }
        },

        /**
         * @description 打印
         */
        async handleSubmit () {
            // 打印前校验
            const isOk = await isValidate(this.printRadio, this.componentsData);
            if (!isOk) return;
            this.checkPrint(this.printRadio);
        },
        // 打印校验
        checkPrint (templateCode) {
            checkPrintCount({ dispatchNo: this.componentsData.dispatchNo, templateCode })
                .then(res => {
                    if (res && +res.code === 0) {
                        if (res.data) {
                            this.handlePrint();
                        } else if (this.validateProfessionalCompany()) {
                            this.isShowPrintReasonDialog = true;
                        } else {
                            this.handlePrint();
                        }
                    } else {
                        this.handlePrint();
                    }
                }).catch(() => {});
        },
        // 专司卡控
        validateProfessionalCompany () {
            const professionalCompany = this.componentsData.professionalCompany;
            this.tooltip = '';
            if (this.CPLimit && this.LDLimit) {
                // 城配开启，零担开启，含有城配/零担都需要备注（城配、零担、城配+其他、零担+其他、城配+零担）
                return professionalCompany && (professionalCompany.includes('城配') || professionalCompany.includes('零担'));
            } else if (this.CPLimit && !this.LDLimit) {
                // 城配开启，零担关闭，含有城配都需要备注（城配、城配+零担、城配+其他）
                if (professionalCompany.includes('城配') && professionalCompany.includes('零担')) {
                    this.tooltip = '因城配送装专司对单据补打管控，本发车单含有城配单据，请您选择补打原因';
                }
                return professionalCompany && professionalCompany.includes('城配');
            } else if (!this.CPLimit && this.LDLimit) {
                // 城配关闭，零担开启，含有零担都需要备注（零担、零担+其他、城配+零担）
                if (professionalCompany.includes('城配') && professionalCompany.includes('零担')) {
                    this.tooltip = '因基地干线专司对单据补打管控，本发车单含有基地单据，请您选择补打原因';
                }
                return professionalCompany && professionalCompany.includes('零担');
            } else {
                // 城配关闭，零担关闭，所有专司都不需要备注
                return false;
            }
        },
        handlePrint (data, repeatPrintReason) {
            this.$nextTick(() => {
                if (repeatPrintReason) {
                    this.repeatPrintReason = repeatPrintReason;
                } else {
                    this.repeatPrintReason = {};
                }
                dealWithPrintLogic(this); // 处理打印逻辑`
            });
        },
        openPrintLog () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print-log');
            this.isShowPrintLogDialog = true;
        },
        // 关闭老版，不关闭新版，不刷新页面
        beforeClose () {
            this.$emit('handleBillClose', '');
        },
        // 关闭老版，关闭新版，不刷新页面
        beforeCloseAllDialog () {
            this.$emit('handleBillClose', 'closePrintDialog');
        }
    },
    mounted () {
        this.CPLimit = this.professionalCompanyConfig.printCompanyConfig || false;
        this.LDLimit = this.professionalCompanyConfig.printLclConfig || false;
        this.visible = true;
    }
};
</script>
<style lang="less">
.performanceDispatchPrintDialog {
    .el-dialog__body {
        padding: 24px 0 0;
        max-height: 500px;
        overflow: auto;
    }
    .performanceDispatchPrintWapper {
        padding: 0 24px;
    }
    .el-radio-group {
        width: 100%;
        .el-icon-question {
            position: absolute;
            font-size: 16px;
            right: 10px;
        }
    }
    .el-collapse-item__header {
        padding-left: 10px;
    }
    .el-collapse-item__header,
    .el-collapse-item__wrap {
        border-bottom: none;
    }
}
</style>
